import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';
import { SaveOutlined } from '@ant-design/icons';

import { Formik, Form, Field } from 'formik';
import { Card, Row, Col, Typography, Space } from 'antd';
import { FormikSelect, FormikButton, FormikInput } from '../../Components/Formik';
import PcnSyncSettingActions from '../../Stores/PcnSyncSetting/Actions';

const { Text } = Typography;

class PcnSyncSetting extends React.PureComponent {
  constructor() {
    super();

    this.handleItemSearch = this.handleItemSearch.bind(this);
  }

  componentDidMount() {
    const { fetchSettings } = this.props;
    fetchSettings();
  }

  componentDidUpdate() {}

  componentWillUnmount() {}

  handleItemSearch(form, value) {
    const { fetchItemOptions } = this.props;

    fetchItemOptions(value);
  }

  render() {
    const {
      intl,
      fetchIsLoading,
      exportIsLoading,
      settings,
      saveSettings,
      itemIsLoading,
      itemOptions
    } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={settings}
        onSubmit={(values, formikBag) => {
          console.log(settings);
          saveSettings(formikBag, values);
        }}
      >
        {({ isSubmitting, handleSubmit }) => (
          <Form>
            <Card>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Row type="flex" justify="center" gutter={[8, 8]}>
                  <Col span={3}>
                    <Text>{intl.formatMessage({ id: 'cron' })}</Text>
                  </Col>
                  <Col span={1}>
                    <Text>:</Text>
                  </Col>
                  <Col span={20}>
                    <Field name="cron" component={FormikInput} />
                  </Col>
                </Row>

                <Row type="flex" justify="center" gutter={[8, 8]}>
                  <Col span={3}>
                    <Text>{intl.formatMessage({ id: 'item' })}</Text>
                  </Col>
                  <Col span={1}>
                    <Text>:</Text>
                  </Col>
                  <Col span={20}>
                    <Field
                      name="item_ids_select2"
                      component={FormikSelect}
                      showArrow
                      filterOption={false}
                      onSearch={this.handleItemSearch}
                      notFoundContent={null}
                      loading={itemIsLoading}
                      options={itemOptions}
                      disabled={isSubmitting}
                      selectMode="multiple"
                    />
                  </Col>
                </Row>

                <Row type="flex" justify="end" gutter={[0, 16]}>
                  <Col>
                    <Field
                      type="primary"
                      name="submit_action"
                      value="save"
                      component={FormikButton}
                      loading={isSubmitting || fetchIsLoading || exportIsLoading}
                      onClick={handleSubmit}
                      label={intl.formatMessage({ id: 'save' })}
                      icon={<SaveOutlined />}
                    />
                  </Col>
                </Row>
              </Space>
            </Card>
          </Form>
        )}
      </Formik>
    );
  }
}

PcnSyncSetting.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  settings: PropTypes.shape({}),

  fetchIsLoading: PropTypes.bool,
  exportIsLoading: PropTypes.bool,

  fetchSettings: PropTypes.func,
  saveSettings: PropTypes.func,

  fetchItemOptions: PropTypes.func,
  itemIsLoading: PropTypes.bool,
  itemOptions: PropTypes.arrayOf(PropTypes.object)
};

PcnSyncSetting.defaultProps = {
  intl: {},

  settings: {
    cron: '',
    item_ids_select2: []
  },

  fetchIsLoading: false,
  exportIsLoading: false,

  fetchSettings() {},
  saveSettings() {},

  fetchItemOptions() {},
  itemIsLoading: false,
  itemOptions: []
};

const mapStateToProps = state => ({
  settings: state.pcnSyncSetting.settings,
  fetchIsLoading: state.pcnSyncSetting.fetchIsLoading,
  exportIsLoading: state.pcnSyncSetting.exportIsLoading,

  itemIsLoading: state.pcnSyncSetting.itemIsLoading,
  itemOptions: state.pcnSyncSetting.itemOptions
});

const mapDispatchToProps = dispatch => ({
  fetchSettings: () => dispatch(PcnSyncSettingActions.pcnSyncSettingShowSetting()),
  saveSettings: (formikBag, settings) =>
    dispatch(PcnSyncSettingActions.pcnSyncSettingSaveSetting(formikBag, settings)),

  fetchItemOptions: search => dispatch(PcnSyncSettingActions.pcnSyncSettingFetchItemOptions(search))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PcnSyncSetting));
